import { render, staticRenderFns } from "./e-orm-table-column-with-action.vue?vue&type=template&id=1392932a&scoped=true&lang=pug&"
import script from "./e-orm-table-column-with-action.vue?vue&type=script&lang=js&"
export * from "./e-orm-table-column-with-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1392932a",
  null
  
)

export default component.exports